module.exports = App.Privilege = DS.Model.extend
  subject:     DS.attr 'string'
  actions:     DS.attr 'mixed'
